import { render } from "./Transcript.vue?vue&type=template&id=3c193acf"
import script from "./Transcript.vue?vue&type=script&lang=js"
export * from "./Transcript.vue?vue&type=script&lang=js"

import "./Transcript.vue?vue&type=style&index=0&id=3c193acf&lang=scss"

import exportComponent from "/Users/kurlov/WebstormProjects/2024/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__